
import React from 'react';
import Footer from '../Footer'
import Hero from '../Hero' 
import '../home/home.css'
 
function Home (){
    return <main>
        <Hero/> <Footer/>
    </main>

    
}
 
export default Home;